module.exports = __webpack_public_path__ + "img/cyprus.7a823e41.svg";